module.exports = __webpack_public_path__ + "static/5-6d4a34751308a6d529da69f3a1843b5f.jpeg";